import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useBattleGamePopupStyles = createUseStyles((theme: Theme) => {
    return {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.82)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            zIndex: 10000,
            paddingTop: '2rem',
            boxSizing: 'border-box' as const,
        },
        popup: {
            backgroundColor: '#4a3824',
            border: '2px dotted #e9d4a8',
            borderRadius: '4px',
            padding: '2rem',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxSizing: 'border-box' as const,
        },
        grid: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
            marginTop: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
                alignItems: 'flex-start',
            },
        },
        leftColumn: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
        rightColumn: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(3),
            [theme.breakpoints.up('md')]: {
                borderLeft: '1px solid rgba(233,212,168,0.2)',
                paddingLeft: theme.spacing(4),
                justifyContent: 'center',
                minHeight: '400px',
            },
        },
        extraSurprize: {
            fontFamily: theme.fonts.poplar,
            color: '#e9d4a8',
            fontSize: '2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            textTransform: 'uppercase' as const,
            lineHeight: 1.2,
            [theme.breakpoints.up('md')]: {
                fontSize: '2.5rem',
            },
        },
        leftSubtitleBold: {
            fontFamily: theme.fonts.apex,
            color: '#e9d4a8',
            fontSize: '1rem',
            fontWeight: 'bold',
            textAlign: 'center',
            [theme.breakpoints.up('md')]: {
                fontSize: '1.05rem',
            },
        },
        leftSubtitle: {
            fontFamily: theme.fonts.apex,
            color: '#e9d4a8',
            fontSize: '0.9rem',
            textAlign: 'center',
            lineHeight: 1.5,
        },
        felicitari: {
            fontFamily: theme.fonts.poplar,
            color: '#e9d4a8',
            fontSize: '2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            [theme.breakpoints.up('md')]: {
                fontSize: '2.5rem',
            },
        },
        rightDescription: {
            fontFamily: theme.fonts.apex,
            color: '#e9d4a8',
            fontSize: '0.92rem',
            textAlign: 'center',
            lineHeight: 1.6,
        },
        scoreBadge: {
            backgroundColor: '#4a7c3f',
            color: '#e9d4a8',
            fontFamily: theme.fonts.poplar,
            fontSize: '1.6rem',
            fontWeight: 'bold',
            padding: `${theme.spacing(1)} ${theme.spacing(5)}`,
            borderRadius: '6px',
            border: '3px solid #6aab5e',
            letterSpacing: '1px',
            display: 'inline-block',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
        },
        backButton: {
            backgroundColor: '#f5e8c9',
            color: '#4a3824',
            fontFamily: theme.fonts.apex,
            fontWeight: 'bold',
            fontSize: '1rem',
            padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            textTransform: 'uppercase' as const,
            letterSpacing: '1px',
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: '#ffffff',
            },
        },
        submitButton: {
            backgroundColor: '#f5e8c9',
            color: '#4a3824',
            fontFamily: theme.fonts.apex,
            fontWeight: 'bold',
            fontSize: '1.1rem',
            padding: `${theme.spacing(1.5)} ${theme.spacing(5)}`,
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            textTransform: 'uppercase' as const,
            letterSpacing: '1px',
            alignSelf: 'center',
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: '#ffffff',
            },
        },
        successMessage: {
            fontFamily: theme.fonts.apex,
            color: '#81c784',
            fontSize: '0.95rem',
            textAlign: 'center',
            fontWeight: 'bold',
        },
        errorMessage: {
            fontFamily: theme.fonts.apex,
            color: '#e57373',
            fontSize: '0.85rem',
            textAlign: 'center',
        },
    };
});

export default useBattleGamePopupStyles;